import "./newNotice.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  TextField,
} from "@mui/material";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";
import { useSelector } from "react-redux";

const NewNotice = ({ inputs, title }) => {
  const userIdRedux = useSelector((state) => state.user.userId);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate(); // Initialize navigate

  const { state } = useLocation(); // Access state passed from navigate
  const noticeData = state?.notice || {}; // Extract notice data or use an empty object

  // populate formData with eventData if editing
  const [formData, setFormData] = useState({
    userId: noticeData.userId || userIdRedux,
    noticeTitle: noticeData.noticeTitle || "",
    noticeDescription: noticeData.noticeDescription || "", //detail about notice
    createdDate: noticeData.createdDate || "",
  });

  const [createdDate, setCreatedDate] = useState(noticeData.createdDate || "");

  const [errors, setErrors] = useState({});
  const [backEndError, setBackEndError] = useState("");

  const validateForm = () => {
    const errors = {};

    if (!formData.noticeTitle) errors.noticeTitle = "Notice Title is required.";
    // if (!/^[a-zA-Z\s]+$/.test(formData.title))
    //   errors.title = "Title must be a string.";

    if (!formData.noticeDescription)
      errors.noticeDescription = "Notice Description is required.";

    if (!createdDate) errors.createdDate = "Created Date is required.";
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    // Prepare the form data for submission (add images if available)
    const formDataToSubmit = new FormData();
    formDataToSubmit.append("userId", formData.userId);
    formDataToSubmit.append("noticeTitle", formData.noticeTitle);
    formDataToSubmit.append("noticeDescription", formData.noticeDescription);
    formDataToSubmit.append("createdDate", createdDate);

    /**
     * choosing URL whether to update or add formDataToSubmit.append("userId", formData.userId);
     *
     */
    const MAIN_URL = noticeData._id
      ? `${BASE_URL}/api/notice/updateNotice/${noticeData._id}`
      : `${BASE_URL}/api/notice/addNotice`;

    try {
      let response = "";
      if (noticeData._id) {
        response = await axios.put(MAIN_URL, formDataToSubmit, {
          headers: {
            "Content-Type": "application/json",
          },
        });
      } else {
        response = await axios.post(MAIN_URL, formDataToSubmit, {
          headers: {
            "Content-Type": "application/json",
          },
        });
      }

      if (response.status === 201) {
        setBackEndError(<font color="green">Success TO ADD DATA.</font>);
        navigate("/notice");
      } else if (response.status === 200) {
        setBackEndError(<font color="green">Success TO UPDATE DATA.</font>);
        navigate("/notice");
      } else if (response.status === 401) {
        //alert or show error message
        setBackEndError(<font color="red">USER ALREADY EXISTS.</font>);
      } else if (response.status === 400) {
        //alert or show error message
        setBackEndError(<font color="red">ALL THE FIELDS ARE REQUIRED.</font>);
      } else if (response.status === 402) {
        //alert or show error message
        setBackEndError(<font color="red">INVALID USER DATA.</font>);
      }
    } catch (error) {
      const errorMessage = error.response.data.msg;
      setBackEndError(<span style={{ color: "red" }}>{errorMessage}</span>);
    }
  };

  return (
    <div className="newUser">
      <Sidebar />
      <div className="newUserContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <form
            onSubmit={handleSubmit}
            style={{
              display: "grid",
              gap: "1rem",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", gap: "16px" }}>
              <div style={{ flex: 3 }}>
                <InputLabel style={{ flex: 1 }}>Created Date</InputLabel>
                <FormControl
                  style={{ flex: 2 }}
                  margin="normal"
                  error={Boolean(errors.createdDate)}
                >
                  <NepaliDatePicker
                    inputClassName="form-control"
                    value={createdDate}
                    onChange={(value) => setCreatedDate(value)}
                    options={{ calenderLocale: "ne", valueLocale: "en" }}
                  />
                  {errors.createdDate && (
                    <FormHelperText>{errors.createdDate}</FormHelperText>
                  )}
                </FormControl>
              </div>

              <label style={{ visibility: "hidden", flex: 9 }}></label>
            </div>

            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 6 }}
                name="noticeTitle"
                label="Notice Title"
                type="text"
                value={formData.noticeTitle}
                onChange={handleChange}
                error={Boolean(errors.noticeTitle)}
                helperText={errors.noticeTitle}
                fullWidth
                margin="normal"
                required
              />
              {/* this label is only for occupy some spaces */}
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>

            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 6 }}
                name="noticeDescription"
                label="Description"
                value={formData.noticeDescription}
                onChange={handleChange}
                multiline
                rows={4} // Number of rows for the text area
                fullWidth
                variant="outlined"
                error={Boolean(errors.noticeDescription)}
                helperText={errors.noticeDescription}
                margin="normal"
                required
              />
              {/* this label is only for occupy some spaces */}
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>

            <span className="error-message">{backEndError}</span>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{ borderRadius: "15px", width: "50%" }}
            >
              Submit
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewNotice;
